import { render, staticRenderFns } from "./BuscarPorEtiquetas.vue?vue&type=template&id=3cf630d4&"
import script from "./BuscarPorEtiquetas.vue?vue&type=script&lang=js&"
export * from "./BuscarPorEtiquetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports